import { useTheme, Breakpoint } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { WellSaidTheme } from '../theme';

export type BreakpointOrNull = Breakpoint | null;

/**
 * Ref: https://material-ui.com/components/use-media-query/#migrating-from-withwidth
 *
 * Be careful using this hook. It only works because the number of
 * breakpoints in theme is static. It will break once you change the number of
 * breakpoints. See https://reactjs.org/docs/hooks-rules.html#only-call-hooks-at-the-top-level
 */
function useBreakpoint(): BreakpointOrNull {
  const theme = useTheme<WellSaidTheme>();
  const keys: Breakpoint[] = [...theme.breakpoints.keys].reverse();
  const matchedBreakpoint = keys.reduce(
    (output: BreakpointOrNull, key: Breakpoint) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useMediaQuery(theme.breakpoints.up(key));
      return !output && matches ? key : output;
    },
    null
  );
  if (matchedBreakpoint === null) {
    // TODO: This is an SSR scenario where we do not have a browser agent with defined width.
    // We should find a way to predict the device/browser width based on user agent. There _may_
    // be more supporting information here: https://material-ui.com/components/use-media-query/
  }
  return matchedBreakpoint;
}

export default useBreakpoint;
